import Image from 'next/image'
import styles from './hsrpSaftySystems.module.scss'

const HsrpSaftySystems = ({ content }) => {
  const keyFeatures = content?.KeyFeatures || []
  const productWarning = content?.ProductWidgetSubHeading

  return (
    <div className={styles.saftySystemsContainer}>
      <span className={styles.saftyWarning}>{productWarning}</span>
      <div className={styles.saftySystems}>
        {keyFeatures?.map(item => {
          const iconUrl = item?.KeyFeatureIcon?.data?.attributes?.url
          return (
            <div className={styles.keyFeatureItem} key={item?.id}>
              {iconUrl && (
                <Image src={iconUrl} alt="Key Feature Icon" width={110} height={56} className={styles.keyFeatureIcon} />
              )}
            </div>
          )
        })}
      </div>
    </div>
  )
}

export default HsrpSaftySystems
